<div class="modal-header">
    <h5 class="modal-title">New Proposal Template</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
  <form [formGroup]="proposalForm">
    <div class="template-name">
        <label for="template">Name</label>
        <input formControlName="groupTemplateName" id="template" type="text" class="form-control" >
    </div>
    </form>
</div>
<div class="modal-footer">
    <button (click)="saveProposalTemplate()" type="button" class="btn btn-primary">
        <span>Save</span>
    </button>
    <button type="button" class="btn btn-secondary ms-2" (click)="modal.dismiss();">Cancel</button>
</div>
